export default "__VITE_ASSET__44715eae__"